module.exports = __webpack_public_path__ + "static/media/tp_sea_star.b33b22ce.jpg";